import React from "react";
import PropTypes from "prop-types";
import { capitalize } from "lodash";
import CustomCheckBox from "./CustomCheckBox";
import CustomCheckBoxLabel from "./CustomCheckBoxLabel";
import CustomCheckBoxIcon from "./CustomCheckBoxIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBellSlash } from "@fortawesome/free-solid-svg-icons";

const SpotCheckBox = props => {
  const { spot, handleChange, handleBlur, values } = props;
  const checked = values[`${spot}`];
  return (
    <CustomCheckBoxLabel>
      {capitalize(spot)}
      <CustomCheckBoxIcon role="button" checked={checked}>
        <CustomCheckBox
          type="checkbox"
          name={spot}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values[`${spot}`]}
          checked={checked}
        />
        {checked ? (
          <FontAwesomeIcon icon={faBell} color="#80D8FF" />
        ) : (
          <FontAwesomeIcon icon={faBellSlash} color="#ccc" />
        )}
      </CustomCheckBoxIcon>
    </CustomCheckBoxLabel>
  );
};

SpotCheckBox.propTypes = {
  spot: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
};

export default SpotCheckBox;
